<template>
	<app background="#fff">
		<organize-edit ref="organizeEdit"></organize-edit>
		
		<button-list-m slot="foot">
			<c-button @click="submit">确认并提交</c-button>
		</button-list-m>
	</app>
</template>

<script>
	import organizeEdit from './organize_edit_form.vue'
	
	export default {
		components: {
			organizeEdit
		},
		
		props: {
			id: String
		},
		
		mounted() {
			if (this.id) {
				this.$refs.organizeEdit.edit(this.id);
			} else {
				this.$refs.organizeEdit.add();
			}
		},
		
		methods: {
			submit() {
				this.$refs.organizeEdit.submit().then(() => {
					this.$message({
						text: '提交成功',
						resolve: () => {
							this.navigateTo('/system_list');
						}
					});
				});
			}
		}
	};
</script>

<style lang="stylus" scoped>
</style>